import { components } from '@/types/api';
import ProcessingReceiptItem from './ProcessingReceiptItem';
import ReceiptItem from './ReceiptItem';
import { Fragment } from 'react/jsx-runtime';

export default function ReceiptList({
  receipts,
}: {
  receipts: components['schemas']['Receipt'][];
}) {
  return (
    <div className="no-scrollbar max-h-[60vh] grow overflow-hidden overflow-y-auto rounded-xl bg-white p-3">
      <div className="divide-y divide-gray-100">
        {receipts?.map((receipt) => (
          <Fragment key={receipt.id}>
            {receipt.status === 'processing' ? (
              <ProcessingReceiptItem receiptId={receipt.id} />
            ) : (
              <ReceiptItem receipt={receipt} />
            )}
          </Fragment>
        ))}
        {receipts?.length === 0 && (
          <Fragment>
            <p>No receipts found</p>
          </Fragment>
        )}
      </div>
    </div>
  );
}
